export default function () {
  const titleList = new Map([
    [1, '维保信息确认'],
    [2, '发起支付'],
    [3, '维修完成确认'],
  ])
  return {
    titleList,
  }
}
